import { gql } from '@provision/graphql-client';
import { CONVERSATION_ASSIGNEE_GROUP_MANAGEMENT_FIELDS } from './conversation-assignee-group.fragments';

export const GET_ENABLED_ASSIGNEE_GROUPS_QUERY = gql`
  query GetEnabledConversationAssigneeGroups($partnerId: Int)
  @entity(name: "ConversationAssigneeGroup") {
    getEnabledConversationAssigneeGroups(partnerId: $partnerId) {
      records {
        id
        conversationAssigneeGroupId
        icon
        name
        partnerId
      }
    }
  }
`;

export const GET_CONVERSATION_ASSIGNEE_GROUPS_MANAGEMENT_QUERY = gql`
  query GetConversationAssigneeGroupsManagement($params: QueryParams)
  @entity(name: "ConversationAssigneeGroup") {
    getConversationAssigneeGroup(queryParams: $params) {
      records {
        ...ConversationAssigneeGroupManagementFields
      }
    }
  }
  ${CONVERSATION_ASSIGNEE_GROUP_MANAGEMENT_FIELDS}
`;

export const CREATE_CONVERSATION_ASSIGNEE_GROUP_MUTATION = gql`
  mutation CreateConversationAssigneeGroup(
    $partnerId: Int!
    $name: String!
    $description: String
    $icon: String
  ) {
    createConversationAssigneeGroup(
      data: { partnerId: $partnerId, name: $name, description: $description, icon: $icon }
    ) {
      ...ConversationAssigneeGroupManagementFields
    }
  }
  ${CONVERSATION_ASSIGNEE_GROUP_MANAGEMENT_FIELDS}
`;

export const UPDATE_CONVERSATION_ASSIGNEE_GROUP_MUTATION = gql`
  mutation UpdateConversationAssigneeGroup(
    $id: String!
    $name: String
    $description: String
    $icon: String
  ) {
    updateConversationAssigneeGroup(
      conditions: [{ attribute: "id", operator: "=", value: $id }]
      data: { name: $name, description: $description, icon: $icon }
    ) {
      ...ConversationAssigneeGroupManagementFields
    }
  }
  ${CONVERSATION_ASSIGNEE_GROUP_MANAGEMENT_FIELDS}
`;
